import React from 'react';
import { sbEditable } from '@storyblok/storyblok-editable';

export const loadComponents = context => context.keys().forEach(context);

const componentMapping = {};

export const render = (blok, pageContext = {}) => {
	if (!blok) {
		return null;
	}
	const blokArray = Array.isArray(blok) ? blok : [blok];
	const bloks = blokArray.map(childBlok => (
		<DynamicComponent pageContext={pageContext} blok={childBlok} key={childBlok._uid} />
	));
	return bloks.length === 1 ? bloks[0] : bloks;
};

export const renderChildBloks = (propNames = [], blok, pageContext) =>
	propNames.reduce((acc, propName) => ({ ...acc, [propName]: render(blok[propName], pageContext) }), {});

export const compose = (name, component, config = {}) => {
	componentMapping[name] = { ...config, component };
};

export const getComponentProps = (blok, component, pageContext) => {
	const { mapBlokToProps, children } = componentMapping[component];
	const props = mapBlokToProps ? mapBlokToProps(blok, pageContext) : blok;
	const childProps = renderChildBloks(children, blok, pageContext);
	return { ...props, ...childProps };
};

export const getComponentElement = component => componentMapping[component].component;

export const hasMapping = componentName => Object.keys(componentMapping).includes(componentName);

export function DynamicComponent({ blok, pageContext }) {
	const { component } = blok;

	if (!hasMapping(component)) {
		return (
			<p>
				The component <strong>{component}</strong> has not been created yet.
			</p>
		);
	}

	const Component = getComponentElement(component);
	return (
		<Component
			{...getComponentProps(blok, component, pageContext)}
			elementProps={sbEditable(blok)}
			pageContext={pageContext}
		/>
	);
}
